export default "__VITE_ASSET__CykPr_FY__"